export default __webpack_public_path__ + "static/media/get-ready.8370c3a2.png";